// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card_uAW07{max-width:100%;display:block;background:#1c2735;color:#fff;padding:12px 4px;border-radius:8px;cursor:pointer}.cover_69fb1{position:relative;width:100%;height:228px;margin-bottom:8px}.cover__img_5aK1u{display:block;margin:auto;width:max-content;max-width:100%;height:100%;object-fit:contain;border-radius:8px}.like_i6cFX{height:24px;width:24px}.likeActive_QBcW7 path{fill:#1e88e5}.likeContainer_m9OYS{position:absolute;bottom:12px;right:8px;display:flex;align-items:center;justify-content:center;background:#232f3f;border-radius:8px;height:40px;width:40px;margin-left:12px;cursor:pointer}.body_elsmk{margin-top:8px;padding:0 8px}.title_NTdMW{margin:0 0 4px;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:18px;font-weight:500;line-height:24px}.type_TcaAy{color:#90a4ae;font-size:14px;font-weight:400;line-height:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": "card_uAW07",
	"cover": "cover_69fb1",
	"cover__img": "cover__img_5aK1u",
	"like": "like_i6cFX",
	"likeActive": "likeActive_QBcW7",
	"likeContainer": "likeContainer_m9OYS",
	"body": "body_elsmk",
	"title": "title_NTdMW",
	"type": "type_TcaAy"
};
module.exports = ___CSS_LOADER_EXPORT___;
